<template>
  <div class="modal-fade" role="dialog" :data-testid="testId">
    <div
      :class="{
        'white-container': true,
        wide: wide,
        high: high,
        [`width-${this.width}`]: true,
        'close-hidden': noCloseButton,
      }"
    >
      <button
        v-if="!noCloseButton"
        class="icon-close close-the-modal"
        @click.prevent="handleClose"
        data-testid="modalCloseBtn"
      />
      <h2 v-if="heading">{{ heading }}</h2>
      <div class="modal-content">
        <slot />
      </div>
      <hr v-if="line" />
      <div
        v-if="$slots.buttons"
        :class="{
          'modal-actions': true,
          'space-between': justifyModalActions === 'space-between',
          center: justifyModalActions === 'center',
        }"
      >
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalBase",
  emits: ["close"],
  props: {
    heading: {
      type: String,
      default: "",
    },
    noCloseButton: {
      type: Boolean,
      default: false,
    },
    line: {
      type: Boolean,
      default: true,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    high: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "default",
      validator(value) {
        return ["default", "medium", "large", "fullscreen", "xl"].includes(
          value
        );
      },
    },
    justifyModalActions: {
      type: "center" | "space-between",
      default: "space-between",
    },
    testId: {
      type: String,
      default: "modalBase",
    },
  },
  methods: {
    handleClose(e) {
      if (!this.noCloseButton) this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~PublicStyles/_variables.scss";

.error {
  font-family: Ubuntu, sans-serif;
  color: $error;
  font-size: 12px;
  margin-left: 5px;
}

.modal-actions {
  &.center {
    justify-content: center !important;
  }
  &.space-between {
    justify-content: space-between !important;
  }
}

.white-container {
  border-radius: 14px;

  .modal-content {
    width: 100%;
    display: block;
  }

  &.width-default {
    max-width: 300px;
    padding: 10px;
  }

  &.width-medium {
    max-width: 450px;
    padding: 16px;
  }

  &.width-large {
    max-width: 600px;
    padding: 20px;
  }

  &.width-xl {
    max-width: 720px;
    padding: 24px;
  }

  &.width-fullscreen {
    max-width: 95vw;
    padding: 24px;
  }

  &.high {
    height: 90vh;
  }
  &.wide {
    max-width: 780px;

    @media ($mobile) {
      max-width: 95%;
    }
  }
  .close-the-modal {
    margin-right: 10px;
    margin-top: 5px;
    outline: none;
  }
}
</style>
